/*
  Field Ethos — Yotpo reviews widget: replaces the anonymous avatar icon with the reviewer's initials
  (styled in assets/fe-yotpo.css). Yotpo re-renders reviews on pagination/filtering, so this watches for changes.
*/
(function () {
  function initials(name) {
    var parts = (name || '').replace(/[^\p{L}\s'-]/gu, ' ').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '';
    var first = parts[0].charAt(0);
    var last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
    return (first + last).toUpperCase();
  }

  function apply(root) {
    root.querySelectorAll('.yotpo-review').forEach(function (review) {
      var image = review.querySelector('.yotpo-reviewer-image');
      var nameEl = review.querySelector('.yotpo-reviewer-name-text, .yotpo-reviewer-name');
      if (!image || !nameEl) return;
      var text = initials(nameEl.textContent);
      if (!text) return;
      var badge = image.querySelector('.fe-y-initials');
      if (badge && badge.textContent === text) return;
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'fe-y-initials';
        badge.setAttribute('aria-hidden', 'true');
        image.insertBefore(badge, image.firstChild);
      }
      badge.textContent = text;
      image.classList.add('fe-y-has-initials');
    });
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      document.querySelectorAll('.yotpo-reviews-main-widget').forEach(apply);
    }, 50);
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  schedule();
})();
